module.exports = __webpack_public_path__ + "img/fa.a0913d13.png";